const downloadResourceRouter = {
  path: 'download-resource',
  name: 'download-resource',
  component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
  redirect: 'download-resource/design',
  meta: { title: '' },
  children: [
    {
      path: 'design',
      name: 'design',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '设计资源', mdfilepath: '/downloadrescources/DesignResource.md', aimtilelist: ['金山文档icon'] }
    }
  ]
}

export default downloadResourceRouter
